<template>
  <div style="height: 100%; display: flex; flex-direction: column;">
    <!-- 页面标题和操作区 -->
    <div class="flex-wrap flex-between" style="height:60px;padding:0 15px;border-bottom: 1px solid var(--border);">
      <div><Input search placeholder="输入名称查询" v-model="filterText" clearable /></div>
      <div class="flex-wrap split10">
        <Button @click="refreshTasks" icon="md-refresh" :loading="loading">刷新</Button>
      </div>
    </div>

    <!-- 任务列表表格 -->
    <div style="flex: 1; overflow: hidden;height:calc(100% - 60px);position:relative;margin:10px;">
      <BaseTable
        ref="taskTable"
        :columns="taskColumns"
        :data="filteredTasks"
        :loading="loading"
        border
        @event="handleTableEvent"
      />
    </div>

    <!-- 任务详情抽屉 -->
    <Drawer
      v-model="showTaskDetail"
      title="任务执行记录"
      width="800"
      :transfer="false"
      :closable="true"
    >
      <div v-if="selectedTask" style="height: 100%; display: flex; flex-direction: column;">
        <!-- 任务基本信息 -->
        <Card style="margin-bottom: 20px;">
          <h3 slot="title">{{ selectedTask.name }}</h3>
          <div class="task-info">
            <div class="info-row">
              <span class="label">任务ID:</span>
              <span class="value">{{ selectedTask.id }}</span>
            </div>
            <div class="info-row">
              <span class="label">执行规则:</span>
              <span class="value">{{ selectedTask.rule }}</span>
            </div>
            <div class="info-row">
              <span class="label">动作:</span>
              <span class="value">{{ selectedTask.action }}</span>
            </div>
            <div class="info-row">
              <span class="label">状态:</span>
              <Tag :color="getStatusColor(selectedTask.status)">{{ getStatusText(selectedTask.status) }}</Tag>
            </div>
            <div class="info-row">
              <span class="label">是否启用:</span>
              <Tag :color="selectedTask.actived ? 'green' : 'red'">{{ selectedTask.actived ? '已启用' : '已禁用' }}</Tag>
            </div>
            <div class="info-row">
              <span class="label">创建时间:</span>
              <span class="value">{{ formatTime(selectedTask.created_at) }}</span>
            </div>
            <div class="info-row">
              <span class="label">创建人:</span>
              <span class="value">{{ selectedTask.created_by }}</span>
            </div>
          </div>
        </Card>

        <!-- 执行记录表格 -->
        <Card style="flex: 1; overflow: hidden;">
          <h4 slot="title">执行记录 ({{ records.length }})</h4>
          <div style="height: 400px; overflow: hidden;position:relative">
            <BaseTable
              ref="recordTable"
              :columns="recordColumns"
              :data="records"
              :loading="loadingRecords"
              border
            />
          </div>
        </Card>
      </div>
    </Drawer>

    <!-- 加载模态框 -->
    <BaseLoadingModal v-model="loading" title="正在加载任务列表..." />
    <BaseLoadingModal v-model="loadingRecords" title="正在加载执行记录..." />
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'TaskManagement',
  data() {
    return {
      // 数据状态
      tasks: [],
      records: [],
      selectedTask: null,

      // UI 状态
      loading: false,
      loadingRecords: false,
      showTaskDetail: false,
      filterText: '',

      // 表格列配置
      taskColumns: [
        {
          type: 'index',
          width: 120,
        },
        {
          title: '任务名称',
          key: 'name',
          minWidth: 200,
          linkEvent: 'viewDetail',
          render: (h, params) => {
            return h('a', {
              style: {
                color: 'var(--primary)',
                cursor: 'pointer',
              },
              on: {
                click: () => this.viewTaskDetail(params.row),
              },
            }, params.row.name);
          },
        },
        {
          title: '执行规则',
          key: 'rule',
          width: 150,
          render: (h, params) => {
            return h('code', {
              style: {
                padding: '2px 6px',
                background: 'var(--bg3)',
                borderRadius: '3px',
                fontSize: '12px',
              },
            }, params.row.rule);
          },
        },
        {
          title: '动作',
          key: 'action',
          width: 250,
          ellipsis: true,
        },
        {
          title: '状态',
          key: 'status',
          width: 100,
          align: 'center',
          render: (h, params) => {
            const status = params.row.status;
            const color = this.getStatusColor(status);
            const text = this.getStatusText(status);

            return h('Tag', {
              props: {
                color: color,
              },
            }, text);
          },
        },
        {
          title: '启用状态',
          key: 'actived',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: params.row.actived ? 'green' : 'red',
              },
            }, params.row.actived ? '已启用' : '已禁用');
          },
        },
        {
          title: '创建时间',
          key: 'created_at',
          width: 150,
          render: (h, params) => {
            return h('span', this.formatTime(params.row.created_at));
          },
        },
        {
          title: '创建人',
          key: 'created_by',
          width: 120,
        },
      ],

      recordColumns: [
        {
          type: 'index',
          width: 60,
          title: '序号',
        },
        {
          title: '执行时间',
          key: 'created_at',
          width: 150,
          render: (h, params) => {
            return h('span', this.formatTime(params.row.created_at));
          },
        },
        {
          title: '执行状态',
          key: 'status',
          width: 100,
          align: 'center',
          render: (h, params) => {
            const status = params.row.status;
            const color = this.getStatusColor(status);
            const text = this.getStatusText(status);

            return h('Tag', {
              props: {
                color: color,
              },
            }, text);
          },
        },
        {
          title: '执行结果',
          key: 'result',
          render: (h, params) => {
            if (!params.row.result) {
              return h('span', {style: {color: 'var(--subtext3)'}}, '无结果');
            }

            let resultText = '';
            let resultObj = null;

            try {
              resultObj = typeof params.row.result === 'string' ?
                JSON.parse(params.row.result) :
                params.row.result;
              resultText = JSON.stringify(resultObj, null, 2);
            } catch (e) {
              resultText = String(params.row.result);
            }

            if (resultText.length > 100) {
              const shortText = resultText.substring(0, 100) + '...';
              return h('Tooltip', {
                props: {
                  content: resultText,
                  maxWidth: 400,
                  transfer: true,
                },
              }, [
                h('span', {
                  style: {
                    fontFamily: 'monospace',
                    fontSize: '12px',
                  },
                }, shortText),
              ]);
            }

            return h('pre', {
              style: {
                fontFamily: 'monospace',
                fontSize: '12px',
                margin: 0,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-all',
              },
            }, resultText);
          },
        },
      ],
    };
  },

  computed: {
    filteredTasks() {
      if (!this.filterText.trim()) {
        return this.tasks;
      }
      return this.tasks.filter((task) => {
        return task.name && task.name.toLowerCase().includes(this.filterText.toLowerCase().trim());
      });
    },
  },

  mounted() {
    this.$api.afterLogin(() => {
      this.loadTasks();
    });
  },

  methods: {
    // API 调用方法
    async loadTasks() {
      this.loading = true;
      try {
        const response = await this.$api.get('/admin/tasks');
        this.tasks = response.data.data || [];
      } catch (error) {
        this.$Message.error('加载任务列表失败: ' + (error.message || '未知错误'));
        console.error('Failed to load tasks:', error);
      } finally {
        this.loading = false;
      }
    },

    async loadTaskRecords(taskId) {
      this.loadingRecords = true;
      try {
        const response = await this.$api.get(`/admin/tasks/${taskId}`);
        const taskDetail = response.data.data;
        this.records = taskDetail.records || [];
      } catch (error) {
        this.$Message.error('加载任务记录失败: ' + (error.message || '未知错误'));
        console.error('Failed to load task records:', error);
      } finally {
        this.loadingRecords = false;
      }
    },

    // 事件处理方法
    refreshTasks() {
      this.loadTasks();
    },

    async viewTaskDetail(task) {
      this.selectedTask = task;
      this.showTaskDetail = true;
      await this.loadTaskRecords(task.id);
    },

    handleTableEvent(event) {
      switch (event.type) {
        case 'viewDetail':
          this.viewTaskDetail(event.data);
          break;
      }
    },

    // 工具方法
    formatTime(time) {
      if (!time) return '-';
      return moment(time).format('YYYY-MM-DD HH:mm:ss');
    },

    getStatusColor(status) {
      const statusMap = {
        'running': 'blue',
        'success': 'green',
        'failed': 'red',
        'pending': 'orange',
        'stopped': 'gray',
      };
      return statusMap[status] || 'default';
    },

    getStatusText(status) {
      const statusMap = {
        'running': '运行中',
        'success': '成功',
        'failed': '失败',
        'pending': '等待中',
        'stopped': '已停止',
      };
      return statusMap[status] || status || '未知';
    },
  },
};
</script>

<style scoped>
.task-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.label {
  font-weight: 600;
  color: var(--text2);
  min-width: 80px;
  flex-shrink: 0;
}

.value {
  color: var(--subtext2);
  word-break: break-all;
}

/* 表格样式优化 */
:deep(.ivu-table-cell) {
  padding: 8px 12px;
}

:deep(.ivu-drawer-body) {
  padding: 20px;
  height: calc(100% - 60px);
  overflow: hidden;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .task-info {
    gap: 8px;
  }

  .info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .label {
    min-width: unset;
  }
}
</style>
